export const FOXIT_SIGN_FILE_SIZE_LIMIT = 25
export const CONVERT_ZIP_FILE_SIZE_LIMIT = 1024
export const COMBINE_FILE_SIZE_LIMIT = 1024
export const DRIVES_FILE_SIZE_LIMIT = 50
export const FEEDBACK_FILE_SIZE_LIMIT = 8
export const ATTACH_FILE_SIZE_LIMIT = 10
export const TEAMS_UPLOAD_FILE_SIZE_LIMIT = 50
export const COLLABORATION_FILE_SIZE_LIMIT = 30
export const COLLABORATION_INVITE_EMAIL_MSG_LIMIT = 1000
export const PAPER_CHECK_FILE_SIZE_LIMIT = 30;
export const AUTO_LOGIN_WAIT_TIME = 1000 * 30;